import { JSX } from "react";

import { Chip, Theme, useTheme } from "@mui/material";

const getStyles = (theme: Theme) => ({
  dateTimeText: { margin: 0, fontSize: theme.fontSizes.sm, fontWeight: theme.typography.fontWeightRegular },
});

interface DateTimeProps {
  dateTime: string | undefined;
}

function DateTimeTextChip(props: DateTimeProps): JSX.Element {
  const { dateTime } = props;
  const theme = useTheme();
  return <Chip sx={getStyles(theme).dateTimeText} size='small' label={dateTime} />;
}

export default DateTimeTextChip;
